<template>
  <div class="trainingDetail">
    <SOSlotBase :container-name="`trainingDetail`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Detail Training'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div>
          <div class="p-x-20">
            <CardInfoDetail
              :idTraining="detailTraining[0].id"
              :status="detailTraining[0].status_training"
              :batas_Waktu="
                detailTraining[0].status_training == '60_menunggu_pembayaran'
                  ? detailTraining[0].training_pembayaran.expired_at
                  : ''
              "
            />
          </div>
          <hr />

          <div class="p-x-20">
            <InfoUserTraining
              :header="'Nama Program'"
              :value="detailTraining[0].training_jenis.nama"
            />
            <InfoUserTraining
              :header="'Nama Owner'"
              :value="detailTraining[0].nama_owner"
            />
            <InfoUserTraining
              :header="'No Telephone'"
              :value="'+' + detailTraining[0].telp_owner"
            />
          </div>

          <div class="separator-line-dot p-d-8"></div>

          <div class="p-x-20">
            <p class="f-16 f-Overpass f-bold p-t-8">Jadwal Training</p>

            <template
              v-for="(trainingDetail, index) in detailTraining[0]
                .training_detail"
            >
              <JadwalEdit
                :label="'Pertemuan ke ' + (index + 1)"
                :jadwal_start="trainingDetail.jadwal_training_mulai"
                :jadwal_end="trainingDetail.jadwal_training_selesai"
                :status="detailTraining[0].status_training"
                :idjenis="detailTraining[0].training_jenis.id"
                :id_Training_Detail="trainingDetail.id"
                :id_training="detailTraining[0].id"
                :range_date="
                  detailTraining[0].training_jenis_id == 'paid_online'
                    ? getJadwalRange(index)
                    : ''
                "
                :link_zoom="trainingDetail.link_zoom"
                :key="index"
              />
            </template>

            <template
              v-if="
                detailTraining[0].status_training == '40_dibatalkan_oleh_cs'
              "
            >
              <p class="f-16 f-Overpass f-bold f-c-black remove-margin p-t-16">
                Alasan Pembatalan
              </p>
              <p class="f-16 f-Overpass f-c-midgrey remove-margin p-t-8">
                Owner tidak mengkonfirmasi penjadwalan ulang
              </p>
            </template>
          </div>

          <template v-if="detailTraining[0].training_ulasan != null">
            <div class="p-t-16">
              <DataUlasan
                :rating_1="detailTraining[0].training_ulasan.nilai_informatif"
                :rating_2="detailTraining[0].training_ulasan.nilai_kesesuaian"
                :ulasan_1="detailTraining[0].training_ulasan.solusi"
                :ulasan_2="detailTraining[0].training_ulasan.kritik_saran"
              />
            </div>
          </template>

          <div class="position"></div>
          <div class="d-flex-column justify-content-md-end p-y-20">
            <ButtonDetail
              :status="detailTraining[0].status_training"
              :idTraining="params_idTraining"
              :nama_owner="detailTraining[0].owner.nama"
              :email_owner="detailTraining[0].owner.email"
              :telp_owner="detailTraining[0].owner.telp"
              :checkUlasan="detailTraining[0].training_ulasan"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import CardInfoDetail from "../components/CardInfoDetail.vue";
import InfoUserTraining from "../components/InfoUserTraining.vue";
import JadwalEdit from "../components/JadwalEdit.vue";
import DataUlasan from "../components/DataUlasan.vue";
import ButtonDetail from "../components/ButtonDetail.vue";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "TrainingDetail",
  components: {
    SOSlotBase,
    SOTitleBar,
    CardInfoDetail,
    InfoUserTraining,
    JadwalEdit,
    DataUlasan,
    ButtonDetail,
  },
  data() {
    return {
      isLoading: false,
      params_idTraining: this.$route.params.idtraining,
      labelTraining1: "Pertemuan ke 1",
      labelTraining2: "Pertemuan ke 2",
    };
  },

  async mounted() {
    await this.init();
  },

  computed: {
    ...mapGetters(moduleName, {
      detailTraining: "detailTraining",
    }),
  },

  methods: {
    ...mapActions({
      getDetailTraining: `${moduleName}/getDetailTraining`,
    }),

    async init() {
      this.isLoading = true;
      let res = await this.getDetailTraining(this.params_idTraining);
      if (res) {
        this.isLoading = false;
      }
    },

    getJadwalRange(index) {
      if (index == 0) {
        return this.detailTraining[0].training_detail[1].jadwal_training_mulai;
      } else {
        return this.detailTraining[0].training_detail[0].jadwal_training_mulai;
      }
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.position {
  min-height: calc(35vh - 177px);
}
</style>
